import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {MatIconModule} from '@angular/material/icon';


export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-contact-us-dialog',
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.css']
})

export class ContactUsDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ContactUsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/components/contact-us-dialog/contact-us-dialog.component.ts